<template>
  <div class="token-publish">
    <div class="form-row">
      <mu-text-field
        v-model="name"
        label="代币名称："
        :errorText="nameInputErrorText"
        @textOverflow="handleNameInput"
        :maxLength="20"
        hintText="请填写代币名称，如Bitcoin，最多20个字符"
        fullWidth
      />
    </div>
    <div class="form-row">
      <mu-text-field
        v-model="symbol"
        label="代币symbol："
        @input="inputSymbol"
        :errorText="symbolInputErrorText"
        hintText="请填写代币标记符号，如BTC, 最多8个字符"
        fullWidth
      />
    </div>
    <div class="form-row">
      <mu-text-field
        v-model="amount"
        label="发放数量："
        min="1"
        max="1000000000000"
        @input="inputAmount"
        :errorText="amountInputErrorText"
        type="number"
        hintText="最多1000000000000枚"
        fullWidth
      />
    </div>
    <div class="form-row">
      <mu-select-field
        v-model="blockchainId"
        @change="changeBlockchain"
        :labelFocusClass="['label-foucs']"
        label="选择发币底层："
        fullWidth
      >
        <mu-menu-item value="1" title="以太坊" />
        <mu-menu-item value="4" title="EOS" />
        <mu-menu-item value="3" title="墨客" />
      </mu-select-field>
    </div>

    <div class="form-row" v-if="moacTips">
      <p class="danger-tip">MOAC底层发行的代币，是由合约发出，无法通过部分交易所的审计要求，请谨慎使用。</p>
    </div>

    <div class="form-row" v-if="ethTips">
      <p class="danger-tip">ETH底层发行的代币，是由合约发出，无法通过部分交易所的审计要求，请谨慎使用。</p>
    </div>

    <div class="form-row" v-if="eosTips">
      <p class="danger-tip">EOS底层发币会消耗较多内存且不会退回，请保证内存至少大于200KB</p>
    </div>

    <div class="form-row">
      <mu-select-field
        v-model="address"
        :labelFocusClass="['label-foucs']"
        label="选择发币钱包："
        fullWidth
      >
        <mu-menu-item
          v-for="option in availableAddress"
          :key="option.value"
          :value="option.value"
          :title="option.text"
        />
      </mu-select-field>
    </div>
    <mu-raised-button
      label="发行代币"
      :disabled="!address || !name || !nameValid || !symbol || !symbolValid || !amount || !amountValid || publishing"
      @click="publishToken"
      fullWidth
      primary
    />

    <div class="loading-layer" v-if="publishing">
      <mu-circular-progress class="loading-circle" :size="60" />
    </div>
    <!-- <div v-for="log in logList">
            {{log}}
    </div>-->
    <div class="bottom-tips">您在使用过程中有任何问题，或对通证发行有特殊需求，请与我们联系，微信公众号：TokenPocket钱包</div>
  </div>
</template>

<script>
import u from "underscore";
import TokenPublish from "./TokenPublish";
import Axios from "axios";
import $ from "jquery";
import Web3 from "web3";

const DOMAIN = "https://preserver.mytokenpocket.vip";

const addTokenApi = DOMAIN + "/v1/token";

const moac_icon_url = "http://tokenbank.skyfromwell.com/tokens/icons/MOAC.png";
const eth_icon_url = "http://tokenbank.skyfromwell.com/tokens/icons/ETH.png";
const common_icon_url = "http://tokenpocket.gz.bcebos.com/common.png";

export default {
  name: "TokenPublish",
  data() {
    return {
      address: "",
      name: "",
      symbol: "",
      eosTips: false,
      ethTips: true,
      moacTips: false,
      blockchainId: "1",
      amount: "",
      ethInfo: false,
      contractAbi: [
        {
          constant: false,
          inputs: [
            { name: "_initialAmount", type: "uint256" },
            { name: "_name", type: "string" },
            { name: "_decimals", type: "uint8" },
            { name: "_symbol", type: "string" }
          ],
          name: "createERC20Token",
          outputs: [{ name: "", type: "address" }],
          payable: false,
          stateMutability: "nonpayable",
          type: "function"
        },
        {
          inputs: [],
          payable: false,
          stateMutability: "nonpayable",
          type: "constructor"
        }
      ],
      ethWallets: [],
      moacWallets: [],
      eosWallets: [],
      availableAddress: [
        {
          text: "请选择发币的钱包",
          value: ""
        }
      ],
      emptyAddress: [
        {
          text: "请选择发币的钱包",
          value: ""
        }
      ],
      symbolInputErrorText: "",
      nameInputErrorText: "",
      amountInputErrorText: "",
      symbolValid: true,
      nameValid: true,
      amountValid: true,
      logList: [],
      mainEthContract: "0xb9B6885D0Af9914d432871DcBeB20DAa8282A763", // r: 0xC2642484dDE92d5AE9B464894d086485190D2ecC m:0xb9B6885D0Af9914d432871DcBeB20DAa8282A763
      mainMoacContract: "0x462fd008df0f6d4d41f98bf5413fb35a7e339fe0",
      publishing: false
    };
  },
  created() {
    window.web3 = new Web3(
      new Web3.providers.HttpProvider("https://eth1wx73xe.jccdex.cn")
    );
    // window.web3 = new Web3(new Web3.providers.HttpProvider("https://ropsten.infura.io/oaJiGrlgSIEU1bkwyb8s"));
    window.chain3 = new Chain3(
      new Chain3.providers.HttpProvider("https://chain3.mytokenpocket.vip")
    );

    if (window.TPJSBrigeClient) {
      window.TPJSBrigeClient.callMessage(
        "getWalletList",
        '{"type": 1}',
        "onGetWalletList"
      );
      window.TPJSBrigeClient.callMessage(
        "getWalletList",
        '{"type": 3}',
        "onGetWalletList"
      );
      window.TPJSBrigeClient.callMessage(
        "getWalletList",
        '{"type": 4}',
        "onGetWalletList"
      );
    }
    // iOS
    else if (window.webkit) {
      window.webkit.messageHandlers.getWalletList.postMessage({
        body: { params: '{"type": 1}', callback: "onGetWalletList" }
      });
      window.webkit.messageHandlers.getWalletList.postMessage({
        body: { params: '{"type": 3}', callback: "onGetWalletList" }
      });
      window.webkit.messageHandlers.getWalletList.postMessage({
        body: { params: '{"type": 4}', callback: "onGetWalletList" }
      });
    } else {
      alert("请在TokenPocket中使用！");
    }

    window.onGetWalletList = result => {
      let data = JSON.parse(result);

      if (data.wallets && data.wallets.eth) {
        // this.logList.push('拿到eth钱包信息');
        u.each(data.wallets.eth, (item, index) => {
          let option = {
            text: item.name + "(" + item.address + ")",
            value: item.address,
            walletId: item.wallet_id
          };
          this.ethWallets.push(option);
        });
      }
      if (data.wallets && data.wallets.moac) {
        // this.logList.push('拿到moac钱包信息');
        u.each(data.wallets.moac, (item, index) => {
          let option = {
            text: item.name + "(" + item.address + ")",
            value: item.address,
            walletId: item.wallet_id
          };
          this.moacWallets.push(option);
        });
      }

      if (data.wallets && data.wallets.eos) {
        u.each(data.wallets.eos, (item, index) => {
          let option = {
            text: item.name + "(" + item.address + ")",
            value: item.name + "," + item.address,
            walletId: item.wallet_id
          };
          this.eosWallets.push(option);
        });
        this.availableAddress = this.eosWallets;
      }

      switch (this.blockchainId) {
        case "1":
          this.availableAddress = this.ethWallets;
          break;
        case "3":
          this.availableAddress = this.moacWallets;
          break;
        case "4":
          this.availableAddress = this.eosWallets;
          break;
        default:
          this.availableAddress = this.eosWallets;
          break;
      }
    };

    // eos上币完成
    window.onEosCustomToken = result => {
      this.logList.push(result);

      let data = JSON.parse(result);
      // 成功
      if (data.result) {
        this.logList.push("发币成功了");

        var totalSupply = parseInt(this.amount) + ".0000";
        let params = {
          name: this.name,
          symbol: this.symbol,
          blockchain_id: +this.blockchainId,
          bl_symbol: this.symbol,
          decimal: 0,
          precision: 4,
          source: "tokenmaster",
          gas: 60000,
          address: this.address.split(",")[0],
          icon_url: common_icon_url,
          owner_address: this.address.split(",")[0],
          token_type: 1,
          total_status: 1,
          total_supply: totalSupply
        };

        this.logList.push("开始上币");
        this.logList.push(JSON.stringify(params));

        // 上币
        $.post(addTokenApi, params)
          .then(res => {
            this.publishing = false;

            this.logList.push(JSON.stringify(res));

            if (res.result === 0) {
              // 添加
              var tokenId = res.data;
              var walletId = u.find(
                this.eosWallets,
                wl => wl.value === this.address
              ).walletId;

              this.logList.push(tokenId);
              this.logList.push(walletId);

              $.post(DOMAIN + "/v1/wallet/token", {
                token_id: tokenId,
                wallet_id: walletId
              }).always(() => {
                // this.logList.push('暂无跳转');
                this.$router.push("/");
              });
            } else {
              this.logList.push("失败了:" + res.message);
            }
          })
          .catch(err3 => {
            this.publishing = false;
            this.logList.push("添加币报错了：" + err3);
          });
      } else {
        this.logList.push("发币失败了");
        this.publishing = false;
      }
    };

    // 收到签名
    window.onTransactionSigned = result => {
      var signedTransaction = JSON.parse(result);

      // alert('收到的signedTransaction:' + signedTransaction);

      // alert('signedTransaction.rawTransaction: ' + signedTransaction.rawTransaction);

      // this.logList.push(signedTransaction.rawTransaction);

      if (this.blockchainId === "1") {
        web3.eth.sendSignedTransaction(
          signedTransaction.rawTransaction,
          (err, hash) => {
            this.handleSignedTransaction(err, hash);
          }
        );
      } else if (this.blockchainId === "3") {
        chain3.mc.sendRawTransaction(
          signedTransaction.rawTransaction,
          (err, hash) => {
            this.handleSignedTransaction(err, hash);
          }
        );
      }
    };
  },
  methods: {
    publishToken() {
      this.publishing = true;
      var amount = web3.utils.toBN(+this.amount);
      var decimals = web3.utils.toBN(Math.pow(10, 18));

      var num = amount.mul(decimals).toString();
      // this.logList.push('数量');

      // EOS 自己玩
      if (this.blockchainId === "4") {
        // var precision = 4;

        var supply = amount.toString() + ".0000";

        var params = {
          supply,
          account: this.address.split(",")[0],
          token: this.symbol,
          chainId: 4,
          address: this.address.split(",")[1]
        };

        this.logList.push(JSON.stringify(params));

        if (window.TPJSBrigeClient) {
          window.TPJSBrigeClient.callMessage(
            "eosCustomToken",
            JSON.stringify(params),
            "onEosCustomToken"
          );
        } else if (window.webkit) {
          window.webkit.messageHandlers.eosCustomToken.postMessage({
            body: {
              params: JSON.stringify(params),
              callback: "onEosCustomToken"
            }
          });
        }
      }
      // eth 和 moac
      else {
        let MyContract = "";

        let ethContractInstance = new web3.eth.Contract(
          this.contractAbi,
          this.mainEthContract
        );
        if (this.blockchainId === "1") {
          MyContract = ethContractInstance;
        } else {
          var moacContract = new chain3.mc.contract(this.contractAbi);
          MyContract = moacContract.at(this.mainMoacContract);
        }

        var msgData = ethContractInstance.methods
          .createERC20Token(num, this.name, 18, this.symbol)
          .encodeABI();

        this.logList.push("msgData:" + msgData);
        if (this.blockchainId === "1") {
          var promise1 = web3.eth.getGasPrice();
        } else {
          var promise1 = new Promise(function(resolve, reject) {
            function callback(err, data) {
              if (err) {
                reject(err);
              } else {
                resolve(data);
              }
            }
            chain3.mc.getGasPrice(callback);
          });
        }

        // var promise1 = this.blockchainId === '1' ? web3.eth.getGasPrice() : new Promise(resolve, reject) {} ;

        this.logList.push("查price");
        var promise2 = ethContractInstance.methods
          .createERC20Token(num, this.name, 18, this.symbol)
          .estimateGas({ from: this.address });
        this.logList.push("查limit");
        Promise.all([promise1, promise2])
          .then(data => {
            // alert('gasPrice和 Limit 都返回了');
            this.logList.push("gasPrice和 Limit 都返回了");
            // this.logList.push('price:' + data[0]);
            // this.logList.push('limit:' + data[1]);

            let signedMsg = {};
            signedMsg.from = this.address;
            signedMsg.gasPrice = data[0].toString();
            signedMsg.gasLimit = data[1];
            signedMsg.chainId = this.blockchainId;
            signedMsg.to =
              this.blockchainId === "1"
                ? this.mainEthContract
                : this.mainMoacContract;
            signedMsg.data = msgData;
            this.logList.push(JSON.stringify(signedMsg));

            // alert('signedMsg拼好了开始发给客户端：' + JSON.stringify(signedMsg));

            if (window.TPJSBrigeClient) {
              window.TPJSBrigeClient.callMessage(
                "signedTransaction",
                JSON.stringify(signedMsg),
                "onTransactionSigned"
              );
            } else if (window.webkit) {
              window.webkit.messageHandlers.signedTransaction.postMessage({
                body: {
                  params: JSON.stringify(signedMsg),
                  callback: "onTransactionSigned"
                }
              });
            }
          })
          .catch(err => (this.publishing = false));
      }
    },
    handleSymbolInput(isOverflow) {
      this.symbolInputErrorText = isOverflow ? "超过长度限制" : "";
      this.symbolValid = !isOverflow;
    },
    handleNameInput(isOverflow) {
      this.nameInputErrorText = isOverflow ? "超过长度限制" : "";
      this.nameValid = !isOverflow;
    },
    inputAmount(value) {
      if (+value > 1000000000000 || +value < 1 || value.search(/\D/g) !== -1) {
        this.amountInputErrorText = "请填写1-1000000000000之间的数字";
        this.amountValid = false;
      } else {
        this.amountInputErrorText = "";
        this.amountValid = true;
      }
    },
    inputSymbol(value) {
      if (value.length > 8) {
        this.symbolInputErrorText = "超过最大长度8的限制";
        this.symbolValid = false;
      } else if (
        +this.blockchainId === 4 &&
        value.search(/\W|\d|[a-z]/g) !== -1
      ) {
        this.symbolInputErrorText = "EOS只允许大写字母";
        this.symbolValid = false;
      } else {
        this.symbolInputErrorText = "";
        this.symbolValid = true;
      }
    },
    changeBlockchain(value) {
      this.eosTips = false;
      this.ethTips = false;
      this.moacTips = false;

      if (value === "3") {
        if (this.moacWallets.length) {
          this.availableAddress = this.moacWallets;
        } else {
          this.availableAddress = this.emptyAddress;
          this.address = "";
        }

        this.moacTips = true;
      } else if (value === "1") {
        if (this.ethWallets.length) {
          this.availableAddress = this.ethWallets;
        } else {
          this.availableAddress = this.emptyAddress;
          this.address = "";
        }

        this.ethTips = true;
      } else if (value === "4") {
        if (this.eosWallets.length) {
          this.availableAddress = this.eosWallets;
        } else {
          this.availableAddress = this.emptyAddress;
          this.address = "";
        }

        this.eosTips = true;
      }

      setTimeout(() => {
        console.log(this.blockchainId);
        this.inputSymbol(this.symbol);
      }, 0);
    },
    handleSignedTransaction(err, hash) {
      if (!err) {
        // 记录一下 hash
        $.post(DOMAIN + "/v1/publish_token", {
          address: this.address,
          hash: hash,
          blockchain_id: +this.blockchainId
        }).then(res => {
          if (res.result === 0) {
            this.logList.push("hash 已记录");
          } else {
            this.logList.push("失败了:" + res.message);
          }
        });

        // this.logList.push('hash:' + hash);

        let mainObject = this.blockchainId === "1" ? web3.eth : chain3.mc;

        var timer = setInterval(() => {
          mainObject.getTransactionReceipt(hash, (err2, data) => {
            // this.logList.push(data);

            if (!err2) {
              if (data.logs && data.logs[0]) {
                // 已经返回了
                clearInterval(timer);

                // this.logList.push(data.logs[0].address);
                this.logList.push("币的合约地址是：" + data.logs[0].address);
                // alert('币的合约地址是：' + data.logs[0].address);

                // this.addToken(data.logs[0].address);

                var amountBN = web3.utils.toBN(+this.amount);
                var decimalsBN = web3.utils.toBN(Math.pow(10, 18));
                let totalSupply = amountBN.mul(decimalsBN).toString();

                let params = {
                  name: this.name,
                  symbol: this.symbol,
                  blockchain_id: +this.blockchainId,
                  bl_symbol: this.symbol,
                  decimal: 18,
                  source: "tokenmaster",
                  gas: 60000,
                  address: data.logs[0].address,
                  icon_url: common_icon_url,
                  owner_address: this.address,
                  token_type: 1,
                  total_status: 1,
                  total_supply: totalSupply
                };

                this.logList.push(JSON.stringify(params));

                // 上币
                $.post(addTokenApi, params)
                  .then(res => {
                    this.publishing = false;
                    // this.logList.push(JSON.stringify(res));
                    if (res.result === 0) {
                      // 添加
                      var tokenId = res.data;
                      var walletId = "";

                      if (this.blockchainId === "1") {
                        // eth
                        walletId = u.find(
                          this.ethWallets,
                          wl => wl.value === this.address
                        ).walletId;
                      } else {
                        walletId = u.find(
                          this.moacWallets,
                          wl => wl.value === this.address
                        ).walletId;
                      }

                      $.post(DOMAIN + "/v1/wallet/token", {
                        token_id: tokenId,
                        wallet_id: walletId
                      });

                      // 添加完成后 删掉存储的hash
                      $.post(DOMAIN + "/v1/publish_token/delete", {
                        hash: hash
                      }).always(() => {
                        this.$router.push(
                          "/token/detail/" + data.logs[0].address
                        );
                      });
                    } else {
                      this.logList.push("失败了:" + res.message);
                    }
                  })
                  .catch(err3 => {
                    this.publishing = false;
                    this.logList.push("添加币报错了：" + err3);
                  });
              } else {
                this.logList.push("logs是空的");
              }
            } else {
              this.logList.push(err);
              // alert('出错了!' + err);
            }
          });
        }, 3000);
      } else {
        this.publishing = false;
        this.logList.push("sendSignedTranscation出错了" + err);
      }
    }
  }
};
</script>

<style scoped lang="less">
.form-row {
  > label {
    position: absolute;
    line-height: 42px;
    font-size: 16px;
  }
}
.right {
  display: block;
  margin-left: 100px;
}

.loading-layer {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  text-align: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.3);
}

.loading-circle {
  position: relative;
  top: 30%;
}

.bottom-tips {
  color: #999;
  font-size: 12px;
  margin-top: 40px;
}

.danger-tip {
  margin-top: -10px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/TokenPublish.vue